import { fromJS } from 'immutable';

import {
  CHANGE_CREDENTIAL_GROUPS_SEARCH,
  TOGGLE_CREDENTIAL_GROUP_FORM,
  TOGGLE_CREDENTIAL_GROUP_VIEW,
} from 'constants/ActionTypes';

const initialState = fromJS({
  search: null,
  view: {
    isVisible: false,
    groupId: null,
  },
  form: {
    isVisible: false,
    groupId: null,
  },
});

const groupTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CREDENTIAL_GROUPS_SEARCH:
      return state.setIn(['searchGroups'], action.search);
    case TOGGLE_CREDENTIAL_GROUP_FORM:
      if (state.getIn(['form', 'isVisible'])) {
        return state.merge(
          fromJS({
            form: {
              isVisible: false,
              groupId: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            form: {
              isVisible: true,
              groupId: action.groupId,
            },
          }),
        );
      }
    case TOGGLE_CREDENTIAL_GROUP_VIEW:
      if (state.getIn(['view', 'isVisible'])) {
        return state.merge(
          fromJS({
            view: {
              isVisible: false,
              groupId: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            view: {
              isVisible: true,
              groupId: action.groupId,
            },
          }),
        );
      }
    default:
      return state;
  }
};

export default groupTableReducer;
